"use client";

import { useState } from "react";
import { unstable_isUnrecognizedActionError } from "next/navigation";
import { reloadDocument } from "@/lib/document-navigation";
import { EMAIL_FORMAT } from "@shared/formats/email";
import { sendPasswordReset } from "../sign-in-actions";

export function useForgotPassword() {
  const [message, setMessage] = useState<string | null>(null);
  const [isSending, setIsSending] = useState(false);
  const request = async (email: string) => {
    if (!EMAIL_FORMAT.validate(email.trim())) {
      setMessage("Enter your email above, then choose Forgot password.");
      return;
    }
    setIsSending(true);
    try {
      const result = await sendPasswordReset({ email });
      setMessage(
        result.status === "sent"
          ? `If there's an account for ${email.trim()}, we've emailed it a link to reset the password.`
          : result.message,
      );
    } catch (cause) {
      if (unstable_isUnrecognizedActionError(cause)) {
        reloadDocument();
        return;
      }
      setMessage("We couldn't send a reset link. Please try again.");
    } finally {
      setIsSending(false);
    }
  };
  return { message, isSending, request };
}

export function ForgotPasswordButton(props: { isSending: boolean; onClick: () => void }) {
  return (
    <button
      type="button"
      className="text-xs text-muted-foreground underline disabled:opacity-60"
      disabled={props.isSending}
      onClick={props.onClick}
    >
      {props.isSending ? "Sending…" : "Forgot password?"}
    </button>
  );
}
